import { customerServiceOrganizationDetailsEntryPoint } from '@jira/jira-spa-apps-customer-service-organization-details/entrypoint.tsx';
import { l1CustomersProjectProviderResource } from '@jira/jira-router-resources-customer-service-l1-customers-project-provider/services/index.tsx';
import { customerServiceOrganizationDetailsRoute } from '@atlassian/jira-router-routes-customer-services-customers-routes/src/customerServiceOrganizationDetailsRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { EntitlementsEntitlementsQueryResource } from '@atlassian/jira-router-resources-service-desk-customer-service-organization-details/src/services/entitlements-organization-query-resource/index.tsx';
import { OrganizationDetailsPageQueryResource } from '@atlassian/jira-router-resources-service-desk-customer-service-organization-details/src/services/ui-organization-details-page-query-resource/index.tsx';
import { jsmEmailDomainsListResource } from '@atlassian/jira-router-resources-jsm-get-email-domains-list/src/index.tsx';
import { productsJsmOrganizationDetailsResource } from '@atlassian/jira-router-resources-jsm-organization-details/src/index.tsx';

const customerServiceOrganizationDetailsPageEntryPoint = createPageEntryPoint({
	main: customerServiceOrganizationDetailsEntryPoint,
});

export const customerServiceOrganizationDetailsRouteEntry = createEntry(
	customerServiceOrganizationDetailsRoute,
	() => ({
		group: 'customer-service',
		perfMetricKey: 'customer-service.organization-details',
		layout: globalLayout,

		component: ErrorPagesNotFound,

		entryPoint() {
			return fg('berry-6285-customers-l1')
				? customerServiceOrganizationDetailsPageEntryPoint
				: undefined;
		},

		resources: [
			...getNavigationResources(),
			OrganizationDetailsPageQueryResource,
			EntitlementsEntitlementsQueryResource,
			productsJsmOrganizationDetailsResource,
			jsmEmailDomainsListResource,
			l1CustomersProjectProviderResource,
		],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-customer-services-customers-entries/src/customerServiceOrganizationDetailsRouteEntry.tsx',
				whichExportToUse: 'customerServiceOrganizationDetailsRouteEntry',
			},

			enabled: true,
		},
	}),
);
